import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/jensen'

Styxie.Initializers.JensenBlocklists = {
  edit: async(props) => {
    const { default: BlocklistEdit } = await import('@/vue_widgets/jensen/blocklist/edit.vue')
    createVueApp(BlocklistEdit, { props, sidebar })
  }
}
